'use client';

import { GetResponseType } from '@/api/types/api';
import { ApiResponseDefinition } from '@/api/types/api-definition';
import dynamic from 'next/dynamic';
import { FC } from 'react';
import type { NavigationPage } from './wapNavigation/navigation.types';

const SideNavSSR = dynamic(() => import('./wapNavigation/SideNav.m'), { ssr: true });

export interface SideNavWrapperProps {
  navData: GetResponseType<ApiResponseDefinition['GET:/api/nav/lists']>;
  isBot: boolean;
  page: NavigationPage;
  onPageChange: (page: NavigationPage) => void;
}

const SideNavWrapper: FC<SideNavWrapperProps> = ({ navData, page, onPageChange }) => {
  return <SideNavSSR navData={navData} page={page} onPageChange={onPageChange} />;
};

export default SideNavWrapper;
